import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './components/auth/Login';
import AdminLogin from './components/auth/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Campaigns from './pages/Campaigns';
import NewPosition from './pages/NewPosition';
import EditCampaign from './pages/EditCampaign';
import CampaignDetail from './pages/CampaignDetail';
import QuestionBank from './pages/QuestionBank';
import Interviews from './pages/Interviews';
import Candidates from './pages/Candidates';
import Reports from './pages/Reports';
import LiveMonitor from './pages/LiveMonitor';
import Analytics from './components/analytics/Analytics';
import Settings from './components/settings/Settings';
import Administration from "./pages/Administration";
import CandidateLanding from './pages/CandidateLanding';
import CandidateInterviewRoom from './pages/CandidateInterviewRoom';
import CandidateDashboard from './components/dashboard/CandidateDashboard';
import InterviewRoom from './components/interview/InterviewRoom';
import AdminLayout from './components/layout/AdminLayout';
import { ReportsHeaderProvider } from './context/ReportsHeaderContext';
import ReachOutPositions from './pages/ReachOutPositions';
import CrossAppReachOutBridge from './pages/CrossAppReachOutBridge';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/admin/login" replace />} />
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/sso/reachout" element={<CrossAppReachOutBridge />} />
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/admin/dashboard" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
          <Route path="/admin/campaigns/new" element={<AdminLayout><NewPosition /></AdminLayout>} />
          <Route path="/admin/campaigns/:id/edit" element={<AdminLayout><EditCampaign /></AdminLayout>} />
          <Route path="/admin/campaigns/:id" element={<AdminLayout><CampaignDetail /></AdminLayout>} />
          <Route path="/admin/campaigns" element={<AdminLayout><Campaigns /></AdminLayout>} />
          <Route path="/admin/question-bank" element={<AdminLayout><QuestionBank /></AdminLayout>} />
          <Route path="/admin/interviews" element={<AdminLayout><Interviews /></AdminLayout>} />
          <Route path="/admin/monitor" element={<AdminLayout><LiveMonitor /></AdminLayout>} />
          <Route path="/admin/candidates" element={<AdminLayout><Candidates /></AdminLayout>} />
          {/* Adding candidates happens in the Add candidates pop-up; old bookmarks land on Candidates. */}
          <Route path="/admin/candidates/add" element={<Navigate to="/admin/candidates" replace />} />
          <Route
            path="/admin/reports"
            element={
              <ReportsHeaderProvider>
                <AdminLayout>
                  <Reports />
                </AdminLayout>
              </ReportsHeaderProvider>
            }
          />
          <Route path="/admin/analytics" element={<AdminLayout><Analytics /></AdminLayout>} />
          <Route path="/admin/settings" element={<AdminLayout><Settings /></AdminLayout>} />
          <Route path="/admin/administration" element={<AdminLayout><Administration /></AdminLayout>} />
          <Route path="/admin/reachout" element={<AdminLayout><ReachOutPositions /></AdminLayout>} />
          {/* Candidate Routes - Invite token based */}
          <Route path="/interview/:invite_token" element={<CandidateLanding />} />
          {/* Keep sessionId route for backward compatibility */}
          <Route path="/candidate/interview/:sessionId" element={<CandidateInterviewRoom />} />
          {/* Candidate Routes (Legacy - OTP-based) */}
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<CandidateDashboard />} />
          <Route path="/interview/:id" element={<InterviewRoom />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

